/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can switch between seasons and toggle between the drivers’ and constructors’ championships. Data is updated within hours of each Grand Prix finishing.`)
};

const es_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes cambiar entre temporadas y alternar entre los campeonatos de pilotos y constructores. Los datos se actualizan pocas horas después de cada Gran Premio.`)
};

const de_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst zwischen Saisons wechseln und zwischen Fahrer- und Konstrukteurswertung umschalten. Die Daten werden innerhalb weniger Stunden nach jedem Grand Prix aktualisiert.`)
};

const nl_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt wisselen tussen seizoenen en schakelen tussen coureurs- en constructeurskampioenschappen. Data wordt binnen enkele uren na elke Grand Prix bijgewerkt.`)
};

const fr_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez basculer entre les saisons et alterner entre les championnats pilotes et constructeurs. Les données sont mises à jour dans les heures suivant chaque Grand Prix.`)
};

const it_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi passare da una stagione all'altra e alternare tra i campionati piloti e costruttori. I dati vengono aggiornati entro poche ore dal termine di ogni Gran Premio.`)
};

const pt_br2_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode alternar entre temporadas e entre os campeonatos de pilotos e construtores. Os dados são atualizados poucas horas após cada Grande Prêmio.`)
};

const pt_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode alternar entre épocas e entre os campeonatos de pilotos e construtores. Os dados são atualizados poucas horas após cada Grande Prémio.`)
};

const ja_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンを切り替えたり、ドライバーとコンストラクターのチャンピオンシップを切り替えたりできます。データは各グランプリ終了後数時間以内に更新されます。`)
};

const zh_f1_standings_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以在不同赛季之间切换，也可以在车手和车队锦标赛之间切换。数据在每场大奖赛结束后数小时内更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_how_p3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_how_p3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_how_p3", locale)
	if (locale === "en") return en_f1_standings_how_p3(inputs)
	if (locale === "es") return es_f1_standings_how_p3(inputs)
	if (locale === "de") return de_f1_standings_how_p3(inputs)
	if (locale === "nl") return nl_f1_standings_how_p3(inputs)
	if (locale === "fr") return fr_f1_standings_how_p3(inputs)
	if (locale === "it") return it_f1_standings_how_p3(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_how_p3(inputs)
	if (locale === "pt") return pt_f1_standings_how_p3(inputs)
	if (locale === "ja") return ja_f1_standings_how_p3(inputs)
	return zh_f1_standings_how_p3(inputs)
};